import { Link } from "react-router-dom"

import { ChamProjectsOpenButton } from "../ChamProjects/ChamProjects";

import styles from './LandingPage.module.css';
import logo from './assets/logo.png';

export default function LandingPage() {

    return (
        <section className={styles.landingSection}>
         <div  className={styles.content}>
         <div className={styles.logoMain}>   
         <img src={logo} alt="Company Logo" width="150"/>
         </div>
          <div className={styles.ctaDiv}>
   
            <h4>Virtual Design Studio</h4>
              <h2>My Home. My Way</h2>
               <div className={styles.landingControls}>
                <Link to="/floorplans" className={styles.btnPrimary}>Get Started</Link>

                {/* Open champrojects component */}
                <ChamProjectsOpenButton title="My Projects" className={styles.btnPrimary} />
               </div>
           </div>
        </div>  
        </section>
    )
}


